import { StoreState } from '../store-interfaces';

export const selectLandingPages = (state: StoreState) =>
  state.landingPages.entities || [];
